<template>
  <div class="widget-wrapper">
    <div
      :style="wrapperStyle"
      class="d-flex"
    >
      <div
        :style="leftStyle"
        class="flex-1"
      />
      <div
        :style="rightStyle"
        class="flex-1"
      />
    </div>
  </div>
</template>

<script>
import {
  INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_LEFT,
  INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_RIGHT,
} from '~/rails_assets';

export default {
  name: 'InsightsUnusualActivityMembersTableBlur',
  computed: {
    wrapperStyle() {
      return { height: '360px' };
    },
    leftStyle() {
      return {
        background: `url(${INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_LEFT}) top left/190px 360px no-repeat`,
      };
    },
    rightStyle() {
      return {
        background: `url(${INSIGHTS_UNUSUAL_ACTIVITIES_MEMBERS_TABLE_BLUR_RIGHT})  top right/190px 360px no-repeat`,
      };
    },
  },
};
</script>
